import React, { useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { useAuth } from '../store/AuthContext';
import { useToast } from '../store/ToastContext';
import { joinTab } from '../services/tabs';
import { LoadingSpinner } from '../components/LoadingSpinner';

export const JoinTabByLink: React.FC = () => {
  const { tabId } = useParams<{ tabId: string }>();
  const { user, loading } = useAuth();
  const { showToast } = useToast();
  const navigate = useNavigate();

  useEffect(() => {
    const performJoin = async () => {
      if (loading) return;

      if (!tabId) {
        void navigate('/tabs', { replace: true });
        return;
      }

      // If guest, just go to the tab page. The TabDetailsPage will handle "Join as Guest"
      if (!user) {
        void navigate(`/tab/${tabId}`, { replace: true });
        return;
      }

      try {
        const tab = await joinTab(tabId, user.uid);
        showToast("Joined tab successfully!", "success");
        void navigate(`/tab/${tab.id}`, { replace: true });
      } catch {
        showToast("Invalid share link or tab not found", "error");
        void navigate('/tabs', { replace: true });
      }
    };

    void performJoin();
  }, [tabId, user, loading, navigate, showToast]);

  return (
    <div className="flex flex-col items-center justify-center py-20 text-center">
      <LoadingSpinner size="lg" />
      <h2 className="mt-6 text-xl font-bold text-text-heading">Joining Tab...</h2>
      <p className="mt-2 text-sm text-text-muted">Please wait while we set things up.</p>
    </div>
  );
};
